//
//
//
//
//
//
//
//

export default {
  name: 'TermsList',
  data() {
    return {
      list: [
        {
          title: '违法及有害信息投诉举报指引',
          url: '/terms/complaint-reporting',
        },
        {
          title: '清朗.财经类违规信息举报专区',
          url: 'https://www.gelonghui.com/p/491886',
        },
        {
          title: '未成年人网络保护制度',
          url: '/terms/protection-of-minors-online',
        },
        {
          title: '格隆汇社区公约',
          url: '/terms/community-platform-system',
        },
        {
          title: '违法和不良信息清单目录',
          url: '/terms/illegal-and-bad-information',
        },
      ],
    };
  },
};
